import { Market } from "../../contracts";
import { filterOutrightsMarkets } from "../filterOutrightsMarkets";
import { filterOutrightSelections } from "../filterOutrightSelections";
import { sortSelectionsByOdd } from "../sortSelectionsByOdd";
import { observable } from "mobx";

export const prepareOutrightMarkets = (markets: Market[], outrightMarketIds: string[]): Market[] => {
    let outrightMarkets = filterOutrightsMarkets(true, markets, outrightMarketIds)
    return outrightMarkets.map(
        (market: Market) => {
            market.selections = observable.array(filterOutrightSelections(market.selections).sort(sortSelectionsByOdd));
            return market;
        }
    );
}